import {post} from './http'
const baseUrl = '/api/capwhale/course/course'
export const getStudyInterestList = v => post(`${baseUrl}/getStudyInterestList`, v.data, v.success, v.error)
export const uploadStudyInterest = v => post(`${baseUrl}/uploadStudyInterest`, v.data, v.success, v.error)
export const getCourseTask = v => post(`${baseUrl}/getCourseTask`, v.data, v.success, v.error)
export const getCourseDetail = v => post(`${baseUrl}/getCourseDetail`, v.data, v.success, v.error)
export const getCourseDiscuss = v => post(`${baseUrl}/getCourseDiscuss`, v.data, v.success, v.error)
export const getCourseNewDiscuss = v => post(`${baseUrl}/getCourseNewDiscuss`, v.data, v.success, v.error)
export const uploadCourseDiscussInfo = v => post(`${baseUrl}/uploadCourseDiscussInfo`, v.data, v.success, v.error)
export const getCourseMyNotes = v => post(`${baseUrl}/getCourseMyNotes`, v.data, v.success, v.error)
export const uploadCourseNotes = v => post(`${baseUrl}/uploadCourseNotes`, v.data, v.success, v.error)
export const getAllCourseNotes = v => post(`${baseUrl}/getAllCourseNotes`, v.data, v.success, v.error)
export const deleteMyCourseNotes = v => post(`${baseUrl}/deleteMyCourseNotes`, v.data, v.success, v.error)
export const getCourseTaskInfo = v => post(`${baseUrl}/getCourseTaskInfo`, v.data, v.success, v.error)
export const uploadCourseComment = v => post(`${baseUrl}/uploadCourseComment`, v.data, v.success, v.error)
// 获取资料列表
export const getCourseDoc = v => post(`${baseUrl}/getCourseDoc`, v.data, v.success, v.error)
// 记录看视频时间
export const pushLearnRecord = v => post(`${baseUrl}/pushLearnRecord`, v.data, v.success, v.error)
